import React from "react";
import {
  FiSearch,
  FiGrid,
  FiList,
  FiRotateCcw,
  FiGlobe,
  FiCheckCircle,
  FiUser,
} from "react-icons/fi";
import { POST_TABS } from "../constants/postEndpoints";
import "./PostFilterToolbar.css";

const PostFilterToolbar = ({
  activeTab,
  onTabChange,
  searchTerm,
  onSearchChange,
  onSearchSubmit,
  selectedService,
  onServiceChange,
  services = [],
  selectedType,
  onTypeChange,
  propertyTypes = [],
  selectedState,
  onStateChange,
  states = [],
  selectedCity,
  onCityChange,
  cities = [],
  onResetFilters,
  viewMode,
  onViewModeChange,
  showMyTab = true,
  showTabs = true,
}) => {
  return (
    <div className="post-filter-toolbar">
      {/* Top row: Module Tabs */}
      {showTabs && (
      <div className="post-filter-toolbar__tabs">
        <button
          type="button"
          className={`post-filter-tab ${
            activeTab === POST_TABS.ALL ? "post-filter-tab--active" : ""
          }`}
          onClick={() => onTabChange(POST_TABS.ALL)}
        >
          <FiGlobe className="post-filter-tab__icon" />
          <span>All Posts</span>
        </button>

        <button
          type="button"
          className={`post-filter-tab ${
            activeTab === POST_TABS.PREFERRED ? "post-filter-tab--active" : ""
          }`}
          onClick={() => onTabChange(POST_TABS.PREFERRED)}
        >
          <FiCheckCircle className="post-filter-tab__icon" />
          <span>Preferred (Partner)</span>
        </button>

        {showMyTab && (
          <button
            type="button"
            className={`post-filter-tab ${
              activeTab === POST_TABS.MY ? "post-filter-tab--active" : ""
            }`}
            onClick={() => onTabChange(POST_TABS.MY)}
          >
            <FiUser className="post-filter-tab__icon" />
            <span>My Posts</span>
          </button>
        )}
      </div>
      )}

      {/* Bottom row: Search + Select Dropdowns + View Switcher */}
      <div className="post-filter-toolbar__controls">
        {/* Search input form */}
        <form
          className="post-filter-toolbar__search"
          onSubmit={(e) => {
            e.preventDefault();
            if (onSearchSubmit) onSearchSubmit();
          }}
        >
          <FiSearch className="post-filter-toolbar__search-icon" />
          <input
            type="text"
            placeholder="Search by customer, service, city, state..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="post-filter-toolbar__search-input"
          />
          {searchTerm && (
            <button
              type="button"
              className="post-filter-toolbar__clear-btn"
              onClick={() => onSearchChange("")}
            >
              ×
            </button>
          )}
        </form>

        {/* Filters Group */}
        <div className="post-filter-toolbar__selects">
          {/* Service Dropdown */}
          <div className="post-filter-select-wrap">
            <select
              value={selectedService}
              onChange={(e) => onServiceChange(e.target.value)}
              className="post-filter-select"
            >
              <option value="">All Services</option>
              {services.length > 0
                ? services.map((s) => {
                    const name = typeof s === "object" ? s.name || s.service_name : s;
                    const id = typeof s === "object" ? s.id || s.name : s;
                    return (
                      <option key={id} value={name}>
                        {name}
                      </option>
                    );
                  })
                : [
                    "Interior Designer",
                    "Architect",
                    "Contractor",
                    "Civil Construction",
                    "Real Estate Agent",
                    "Property Buy/Sell",
                    "Property Lease/Rent",
                    "Home Loan",
                    "Legal Consultant",
                  ].map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
            </select>
          </div>

          {/* Property Type Dropdown */}
          <div className="post-filter-select-wrap">
            <select
              value={selectedType}
              onChange={(e) => onTypeChange(e.target.value)}
              className="post-filter-select"
            >
              <option value="">All Property Types</option>
              {propertyTypes.map((t) => {
                const name = typeof t === "object" ? t.name : t;
                const id = typeof t === "object" ? t.id || t.name : t;
                return (
                  <option key={id} value={name}>
                    {name}
                  </option>
                );
              })}
            </select>
          </div>

          {/* State */}
          <div className="post-filter-select-wrap">
            <select
              value={selectedState}
              onChange={(e) => onStateChange(e.target.value)}
              className="post-filter-select"
            >
              <option value="">All States</option>
              {states.map((s) => {
                const name = typeof s === "object" ? s.name : s;
                const id = typeof s === "object" ? s.id || s.name : s;
                return (
                  <option key={id} value={name}>
                    {name}
                  </option>
                );
              })}
            </select>
          </div>

          {/* City */}
          <div className="post-filter-select-wrap">
            <select
              value={selectedCity}
              onChange={(e) => onCityChange(e.target.value)}
              className="post-filter-select"
            >
              <option value="">All Cities</option>
              {cities.map((c) => {
                const name = typeof c === "object" ? c.name : c;
                const id = typeof c === "object" ? c.id || c.name : c;
                return (
                  <option key={id} value={name}>
                    {name}
                  </option>
                );
              })}
            </select>
          </div>

          {/* Reset button */}
          {(searchTerm ||
            selectedService ||
            selectedType ||
            selectedState ||
            selectedCity) && (
            <button
              type="button"
              className="post-filter-reset-btn"
              onClick={onResetFilters}
              title="Reset Filters"
            >
              <FiRotateCcw size={14} />
              <span>Reset</span>
            </button>
          )}
        </div>

        {/* View mode toggle */}
        <div className="post-view-toggle">
          <button
            type="button"
            className={`post-view-toggle__btn ${
              viewMode === "grid" ? "post-view-toggle__btn--active" : ""
            }`}
            onClick={() => onViewModeChange("grid")}
            title="Grid View"
          >
            <FiGrid size={16} />
          </button>
          <button
            type="button"
            className={`post-view-toggle__btn ${
              viewMode === "table" ? "post-view-toggle__btn--active" : ""
            }`}
            onClick={() => onViewModeChange("table")}
            title="List / Table View"
          >
            <FiList size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PostFilterToolbar;
